import { SharedProps } from "../../types/SharedProps";

export type NavbarProps = SharedProps & {
    rolledOut?: boolean,
    options?: Option[],
    spanView?: boolean,
    selected?: number,
    itemClassName?: string,
    addClass?: string,
    ref?: any
}

export type Option = SharedProps & {
    onClick?: React.MouseEventHandler<HTMLLIElement>,
    name?: string,
    additionalIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {
        title?: string | undefined;
    }>;
    additionalIconStyle?: React.CSSProperties;
    disabled?: boolean;
    iconAtTheEnd?: boolean;
    key?: number;
}

export enum ClassNameNavbar {
    menu = "navbarMenu",
    default = "navbarDefault",
    threeDots = "threeDots"
}